/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { useFormikContext } from 'formik'

import { Radio } from '@dasa-health/components-react'
import { Container, Title } from './styles'

type UnicoSessProps = {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

export function UnicoSessionDefault({ setFieldValue }: UnicoSessProps) {
    const { values } = useFormikContext<any>()

    const isChecked = values.contact?.type === 'UNICO'

    return (
        <Container>
            <Title>Não reconhece ou não possui acesso aos contatos?</Title>

            <div className="form__radio">
                <Radio
                    checked={isChecked}
                    data-testid="radio-input"
                    label="Atualizar com reconhecimento facial"
                    name="contact"
                    onChange={() =>
                        setFieldValue('contact', {
                            id: null,
                            value: 'unico',
                            type: 'UNICO',
                        })
                    }
                    value="unico"
                />
            </div>
        </Container>
    )
}
